export const ACCESS_TOKEN = '__app_at';
export const USER_DATA = '__app_ud';
// api methods
export const API_METHOD_POST = 'post';
export const API_METHOD_GET = 'get';
export const API_METHOD_PUT = 'put';
export const API_METHOD_PATCH = 'patch';
export const API_METHOD_DELETE = 'delete';

// api headers
export const API_HEADER_1 = 'headers1';
export const API_HEADER_2 = 'headers2';
export const API_HEADER_3 = 'headers3';
export const API_HEADER_4 = 'headers4';
